import { request } from 'beans-admin-plugin';

export function downloadFromUrl(url, fileName, target = '_self') {
  const link = document.createElement('a');
  link.target = target;
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function downloadFromBlob(content, fileName) {
  const href = URL.createObjectURL(content);
  downloadFromUrl(href, fileName);
  URL.revokeObjectURL(href);
}

function getAttachmentNameFromHeader(header) {
  let filename = '';
  const disposition = header['content-disposition'] || header['Content-Disposition'];
  if (disposition && disposition.indexOf('attachment') !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches !== null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
  }
  return decodeURI(filename).replace(/^utf-8/i, '');
}

export async function exportFile(url, params = {}) {
  const { data, headers } = await request.get(url, params, { responseType: 'blob', timeout: 20 * 60 * 1000, return_res: true, loading: false });
  downloadFromBlob(data, getAttachmentNameFromHeader(headers) || 'export.xlsx');
}
